import api from '@/common/api/cobrandApiClient'
import { GAMES } from '@/constants'

export const FETCH_CONDITIONS = 'FETCH_CONDITIONS'
export const FETCH_CONDITIONS_ERROR = 'FETCH_CONDITIONS_ERROR'
export const FETCH_PROGRAMS = 'FETCH_PROGRAMS'
export const FETCH_PROGRAMS_ERROR = 'FETCH_PROGRAMS_ERROR'

export const defaultState = {
  conditions: [],
  goldRate: {
    [GAMES.MT]: null,
    [GAMES.TB]: null,
    [GAMES.MK]: null
  }
}

export const mutations = {
  [FETCH_CONDITIONS] (state, data) {
    state.conditions = data
  },
  [FETCH_PROGRAMS] (state, data) {
    data.forEach(({ game, goldRate }) => {
      state.goldRate[game] = goldRate
    })
  }
}

export const actions = {
  async fetchConditions ({ commit }, partner) {
    try {
      const { data } = await api.fetchExtraRewardsConditions(partner)
      commit(FETCH_CONDITIONS, JSON.parse(data.data[0].conditions))
    } catch (error) {
      // eslint-disable-next-line
      console.info('error:', { error })
      commit(FETCH_CONDITIONS_ERROR, error)
    }
  },
  async fetchPrograms ({ commit }, partner) {
    try {
      const { data } = await api.fetchExtraRewardsPrograms(partner)
      commit(FETCH_PROGRAMS, data.data || [])
    } catch (error) {
      // eslint-disable-next-line
      console.info('error:', { error })
      commit(FETCH_PROGRAMS_ERROR, error)
    }
  },

  async extraBonusCheck ({ commit }, { card, stateId }) {
    try {
      const cardId = card.cardId
      const { data } = await api.extraBonusCheck({
        acc_id: card.acc_id,
        card_states: [{
          card_code_id: cardId,
          state_id: stateId
        }]
      })
      commit(FETCH_PROGRAMS, data.data || [])
    } catch (error) {
      // eslint-disable-next-line
      console.info('error:', { error })
      commit(FETCH_PROGRAMS_ERROR, error)
    }
  }
}

export default {
  namespaced: true,
  state: () => defaultState,
  mutations,
  actions
}
